import React, { useState } from "react";
import "./nav.css";
import { Link } from "react-router-dom"; 

function Nav() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-brand">
        <img className="img1" alt="" src="https://i.imgur.com/JD6tE06.png"/>
        <h1 style={{marginTop:"10px"}} className="r">VIJAYA <span style={{color:'#F8D47A'}}>TRADERS</span></h1>
        </div>

      {/* Hamburger icon */}
      <div
        className="hamburger"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? "✖" : "☰"}
      </div>

      {/* Links */}
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/feed">Feed-Back</Link></li>
        <li><Link to="/dash" style={{color:"white"}}>Dashboard</Link></li>
        <li><a href="#calculator">Calculator</a></li>
        <li><Link to="/inv" style={{color:"white"}}>Investment Opportunities</Link></li>
        <li><Link to="/terms" >Terms and Conditions</Link></li>
      </ul>
    </nav>
  );
}

export default Nav;
